import {ABSOLUTE_REGEX} from "./regexp.ts";

/**
 * We look for something that would indicate that this is a relative URL,
 * like the URL starting with a /.
 *
 * @param {string} url to check
 */
export const isRelativeUrl = (url: string): boolean =>
    !ABSOLUTE_REGEX.test(url);
